module.exports = __webpack_public_path__ + "static/media/undraw_growth_analytics.0ec7f86d.png";